import { skipToken, useQuery } from '@tanstack/react-query';

import { apiClient } from 'core/api/globals';

import { AuthenticationScheme, useAuthentication } from 'features/auth';

export function useQueryLocationsLite() {
  const { activeScheme } = useAuthentication();

  // Only call the API for OIDC users, skip for all other cases
  const shouldFetchLocations = activeScheme === AuthenticationScheme.OIDC;

  return useQuery({
    queryKey: ['locations-lite'],
    queryFn: shouldFetchLocations ? () => apiClient.locationClient.getAllLocationsLite('msal-required') : skipToken,
    staleTime: 1000 * 60 * 5, // 5 minutes cache
  });
}
